import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import MultiSelectFilter from '../MultiSelectFilter';
import { OutpostContext } from '../../../../scenes/OutpostScene/OutpostContext';
const parseTopics = (value: string | null | undefined): string[] => {
  if (!value) return [];
  return value.split(',').map(t => t.trim()).filter(Boolean);
};
const OutpostTopicsFilter: React.FC<{
  name: string;
  title?: string;
  placeholder?: string;
  in_dropdown?: boolean;
  onBack?: () => void;
  onSubmit: () => void;
  onReset: () => void;
}> = t0 => {
  const $ = _c(9);
  const {
    name,
    title,
    placeholder,
    in_dropdown,
    onBack
  } = t0;
  const {
    config
  } = useContext(OutpostContext);
  let t1;
  if ($[0] !== config.TOPICS) {
    t1 = parseTopics(config.TOPICS).map(_temp);
    $[0] = config.TOPICS;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== in_dropdown || $[3] !== name || $[4] !== onBack || $[5] !== options || $[6] !== placeholder || $[7] !== title) {
    t2 = <MultiSelectFilter name={name} options={options} title={title} placeholder={placeholder} in_dropdown={in_dropdown} onBack={onBack} />;
    $[2] = in_dropdown;
    $[3] = name;
    $[4] = onBack;
    $[5] = options;
    $[6] = placeholder;
    $[7] = title;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default OutpostTopicsFilter;
function _temp(topic) {
  return {
    label: topic,
    value: topic
  };
}